import { lazy } from "react";
import TestExecution from "../pages/QTest/TestExecution";
import { CreateQuestionPage } from "../pages/AdminAccess";

const CreateBookTest = lazy(() => import("../pages/Apps/CreateTest/CreateBookTest"));
const TestTypeSelectionPage = lazy(() => import("../pages/Apps/CreateTest/TestTypeSelection"));
const EditBookQuestionPage = lazy(() => import("../pages/AdminAccess/BookQuestion/EditBookQuestion"));
const NewBookQuestionPage = lazy(() => import("../pages/AdminAccess/BookQuestion/NewBookQuestion"));
const BookQuestionsPage = lazy(() => import("../pages/AdminAccess/BookQuestion/BookQuestions"));
const FlashcardSelectionPage = lazy(() => import("../pages/Apps/FlashcardSelection"));
const PerformancePage = lazy(() => import("../pages/Reports/Performance"));
const SimuladosReportPage = lazy(() => import("../pages/Reports/SimuladosReport"));
const EditFlashCardPage = lazy(() => import("../pages/AdminAccess/EditFlashCard"));
const CreateFlashCardPage = lazy(() => import("../pages/AdminAccess/CreateFlashCard"));
const FlashCardAdminPage = lazy(() => import("../pages/AdminAccess/FlashCardAdmin"));
const CreateOpenQuestionPage = lazy(() => import("../pages/AdminAccess/CreateOpenQuestion"));
const QuestionTypeSelectionPage = lazy(() => import("../pages/AdminAccess/QuestionTypeSelection"));
const AnalyticsAdmin = lazy(() => import("../pages/AdminAccess/AnalyticsAdmin"));
const AnswersPage = lazy(() => import("../pages/AdminAccess/Answers"));
const QuestionsPage = lazy(() => import("../pages/AdminAccess/Questions"));
const CategoryPage = lazy(() => import("../pages/AdminAccess/Category"));
const UsersList = lazy(() => import("../pages/AdminAccess/UsersList"));
const Dashboard = lazy(() => import("../pages/Dashboard"));
const CreateTest = lazy(() => import("../pages/Apps/CreateTest"));
const PreviousTest = lazy(() => import("../pages/Apps/PreviousTest"));
const AccountSetting = lazy(() => import("../pages/Users/AccountSetting"));
const ERROR404 = lazy(() => import("../pages/Pages/Error404"));
const ERROR500 = lazy(() => import("../pages/Pages/Error500"));
const ERROR503 = lazy(() => import("../pages/Pages/Error503"));
const Maintenence = lazy(() => import("../pages/Pages/Maintenence"));
const LoginCover = lazy(() => import("../pages/Authentication/LoginCover"));
const ReportsUser = lazy(() => import("../pages/Reports/ReportsUser"));

// Wireframes
const WireFrame = lazy(() => import("../pages/Dashboard/Wireframe"));

const routes = [
    // dashboard
    {
        path: "/",
        element: <WireFrame />
    },

    // App route
    {
        path: "/apps/create_test",
        element: <TestTypeSelectionPage />
    },
    {
        path: "/apps/create_test/custom",
        element: <CreateTest />
    },
    {
        path: "/apps/create_test/book",
        element: <CreateBookTest />
    },
    {
        path: "/apps/previous_tests",
        element: <PreviousTest />
    },
    {
        path: "/apps/flashcard",
        element: <FlashcardSelectionPage />
    },

    // Admin routes
    {
        path: "/admin/users",
        element: <UsersList />
    },
    {
        path: "/admin/questions/category",
        element: <CategoryPage />
    },
    {
        path: "/admin/questions/questions",
        element: <QuestionsPage />
    },
    {
        path: "/admin/questions/create-type-selection",
        element: <QuestionTypeSelectionPage />
    },
    {
        path: "/admin/questions/create-questions",
        element: <CreateQuestionPage />
    },
    {
        path: "/admin/questions/create-open-questions",
        element: <CreateOpenQuestionPage />
    },
    {
        path: "/admin/questions/answers",
        element: <AnswersPage />
    },
    {
        path: "/admin/flashcards",
        element: <FlashCardAdminPage />
    },
    {
        path: "/admin/flashcards/create",
        element: <CreateFlashCardPage />
    },
    {
        path: "/admin/flashcards/edit/:idflashcard",
        element: <EditFlashCardPage />
    },
    {
        path: "/admin/book-questions",
        element: <BookQuestionsPage />
    },
    {
        path: "/admin/book-questions/create",
        element: <NewBookQuestionPage />
    },
    {
        path: "/admin/book-questions/:idbook",
        element: <EditBookQuestionPage />
    },
    {
        path: "/admin/analytics",
        element: <AnalyticsAdmin />
    }, // not implemented yet
    {
        path: "/admin/simulados-report",
        element: <SimuladosReportPage />
    },

    // Setting route (users)
    {
        path: "/users/user-account-settings",
        element: <AccountSetting />
    },

    // Reports page (users)
    {
        path: "/reports/user/general",
        element: <ReportsUser />
    },
    {
        path: "/reports/user/performance",
        element: <PerformancePage />
    },

    // Pages error route
    {
        path: "/pages/error404",
        element: <ERROR404 />,
        layout: "blank"
    },
    {
        path: "/pages/error500",
        element: <ERROR500 />,
        layout: "blank"
    },
    {
        path: "/pages/error503",
        element: <ERROR503 />,
        layout: "blank"
    },
    {
        path: "/pages/maintenence",
        element: <Maintenence />,
        layout: "blank"
    },

    //Test Execution
    {
        path: "/apps/test/:idtest/:index",
        element: <TestExecution />
    },

    //Authentication
    {
        path: "/auth/login",
        element: <LoginCover />,
        layout: "blank"
    },
    {
        path: "*",
        element: <ERROR404 />,
        layout: "blank"
    }
];

export { routes };
